var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRandomLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0H0V5.51724H6.2069L8.62069 8.27586L7.58621 9.31035L5.51724 6.89655H0V13.1034H5.51724L12.4138 4.82759H16.5517V3.44828L19.3103 5.51724L16.5517 7.58621V6.2069H13.1034L6.2069 14.4828H0V20H20V0ZM9.65517 11.7241L10.6897 10.6897L13.1034 13.7931H16.5517V12.4138L19.3103 14.4828L16.5517 16.5517V15.1724H12.4138L9.65517 11.7241Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRandomLayer);
export default __webpack_public_path__ + "static/media/RandomLayer.cd1fdc5f1d877bc9dc143eed1cb56608.svg";
export { ForwardRef as ReactComponent };